import {
  NavItemChildConfig,
  NavItemWithChildren,
} from '@app/components/layout/sidenav/link/NavItemWithChildren';
import { StationIcon } from '@app/components/stations/StationIcon';
import { useDefaultStation } from '@app/core/stations/hooks/useDefaultStation';
import { defineMessage, useIntl } from 'react-intl';
import { LoggerIcon } from './LoggerIcon';

const panoramaLabelMessage = defineMessage({
  id: 'logger.sidenav.panorama',
  defaultMessage: 'Panorama',
});

export function LoggerLinks() {
  const { $t } = useIntl();

  const loggerLabel = $t({
    id: 'logger.navLabel',
    defaultMessage: 'Logger',
  });

  const defaultStation = useDefaultStation();

  const children: NavItemChildConfig[] = [
    {
      label: $t(panoramaLabelMessage),
      to: '/logger/status',
    },
    {
      label: defaultStation.name,
      to: `/logger/s/${defaultStation.slug}`,
      icon: <StationIcon fontSize="inherit" />,
    },
  ];

  return (
    <NavItemWithChildren
      root="/logger"
      label={loggerLabel}
      icon={<LoggerIcon />}
      items={children}
    />
  );
}
